




















import { Vue, Component, Prop } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as images from "../../assets/images";
import { DocPattoFormativo } from "../../_models/docPattoFormativo";
import { bus } from "../../main";

//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component
export default class PattoFormativoAlternanzaReview extends Vue {
  @Prop() docInfo!: DocPattoFormativo;
  private ruoloUtente: number[];

  private elements: DocPattoFormativo;

  private doc: any;

  constructor() {
    super();
    this.ruoloUtente = [];
    this.elements = {
      idPattoFormativo: this.docInfo.idPattoFormativo,
      idRichiesta: this.docInfo.idRichiesta,
      denominazioneIstituto: this.docInfo.denominazioneIstituto,
      cognomeAllievo: this.docInfo.cognomeAllievo,
      nomeAllievo: this.docInfo.nomeAllievo,
      codiceFiscaleAllievo: this.docInfo.codiceFiscaleAllievo,
      luogoNascitaAllievo: this.docInfo.luogoNascitaAllievo,
      dataNascitaAllievo: this.docInfo.dataNascitaAllievo,
      indirizzoAllievo: this.docInfo.indirizzoAllievo,
      comuneAllievo: this.docInfo.comuneAllievo,
      provinciaAllievo: this.docInfo.provinciaAllievo,
      capAllievo: this.docInfo.capAllievo,
      telefonoAllievo: this.docInfo.telefonoAllievo,
      emailAllievo: this.docInfo.emailAllievo,
      classe: this.docInfo.classe,
      cognomeTutore: this.docInfo.cognomeTutore,
      nomeTutore: this.docInfo.nomeTutore,
      relazioneParentale: this.docInfo.relazioneParentale,
      telefonoTutore: this.docInfo.telefonoTutore,
      indirizzoTutore: this.docInfo.indirizzoTutore,
      comuneTutore: this.docInfo.comuneTutore,
      provinciaTutore: this.docInfo.provinciaTutore,
      capTutore: this.docInfo.capTutore,
      statoDocumento: this.docInfo.statoDocumento,
      firmaAllievo: this.docInfo.firmaAllievo,
      firmaTutore: this.docInfo.firmaTutore,
      dataDocumento: this.docInfo.dataDocumento,
      paeseNascitaAllievo: this.docInfo.paeseNascitaAllievo,
      denominazioneAzienda: this.docInfo.denominazioneAzienda,
      indirizzoAzienda: this.docInfo.indirizzoAzienda,
      capAzienda: this.docInfo.capAzienda,
      comuneAzienda: this.docInfo.comuneAzienda,
      provinciaAzienda: this.docInfo.provinciaAzienda,
      telefonoAzienda: this.docInfo.telefonoAzienda,
      emailAzienda: this.docInfo.emailAzienda,
      emailPecAzienda: this.docInfo.emailPecAzienda,
      pIvaAzienda: this.docInfo.pIvaAzienda,
      indirizzoTirocinio: this.docInfo.indirizzoTirocinio,
      comuneTirocinio: this.docInfo.comuneTirocinio,
      provinciaTirocinio: this.docInfo.provinciaTirocinio,
      dataInizioPeriodo: this.docInfo.dataInizioPeriodo,
      dataFinePeriodo: this.docInfo.dataFinePeriodo,
      idTipoAttivita: this.docInfo.idTipoAttivita,
      idTemplate: this.docInfo.idTemplate,
      firmaIstituto: this.docInfo.firmaIstituto
    };
    this.doc = null;
  }

  createDoc() {
    if (this.elements.firmaAllievo === null) {
      this.elements.firmaAllievo = images.noFirma;
    }
    if (this.elements.firmaTutore === null) {
      this.elements.firmaTutore = images.noFirma;
    }

    var finalDocStr: string = this.completeDoc();
    var json = JSON.parse(finalDocStr);
    const pdfDocGenerator = pdfMake.createPdf(json);
    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  completeDoc(): string {
    var completeDoc: string = "";
    completeDoc = JSON.stringify(this.doc);
    completeDoc = completeDoc.replace(/%%_header_%%/g, images.headerDocVallauri);
    completeDoc = completeDoc.replace(/%%_footer_%%/g, images.footerDocVallauri);
    completeDoc = completeDoc.replace(/%%_headerDocVallauri_%%/g, images.headerDocVallauri);
    completeDoc = completeDoc.replace(/%%_footerDocVallauri_%%/g, images.footerDocVallauri);
    completeDoc = completeDoc.replace(
      /%%_denominazioneIstituto_%%/g,
      this.elements.denominazioneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_denominazioneAzienda_%%/g,
      this.elements.denominazioneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoAzienda_%%/g,
      this.elements.indirizzoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_capAzienda_%%/g,
      this.elements.capAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_comuneAzienda_%%/g,
      this.elements.comuneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaAzienda_%%/g,
      this.elements.provinciaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoAzienda_%%/g,
      this.elements.telefonoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_emailAzienda_%%/g,
      this.elements.emailAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pIvaAzienda_%%/g,
      this.elements.pIvaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_dataDocumento_%%/g,
      this.elements.dataDocumento
    );
    completeDoc = completeDoc.replace(
      /%%_cognomeAllievo_%%/g,
      this.elements.cognomeAllievo
    );
    completeDoc = completeDoc.replace(
      /%%_nomeAllievo_%%/g,
      this.elements.nomeAllievo
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaAllievo_%%/g,
      this.elements.luogoNascitaAllievo
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaAllievo_%%/g,
      this.elements.dataNascitaAllievo
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoAllievo_%%/g,
      this.elements.indirizzoAllievo
    );
    completeDoc = completeDoc.replace(
      /%%_comuneAllievo_%%/g,
      this.elements.comuneAllievo
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaAllievo_%%/g,
      this.elements.provinciaAllievo
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoAllievo_%%/g,
      this.elements.telefonoAllievo
    );
    completeDoc = completeDoc.replace(
      /%%_codiceFiscaleAllievo_%%/g,
      this.elements.codiceFiscaleAllievo
    );
    completeDoc = completeDoc.replace(
      /%%_classeTirocinante_%%/g,
      this.elements.classe
    );
    completeDoc = completeDoc.replace(
      /%%_emailAllievo_%%/g,
      this.elements.emailAllievo
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoTirocinio_%%/g,
      this.elements.indirizzoTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_comuneTirocinio_%%/g,
      this.elements.comuneTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaTirocinio_%%/g,
      this.elements.provinciaTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_dataInizioPeriodo_%%/g,
      this.elements.dataInizioPeriodo
    );
    completeDoc = completeDoc.replace(
      /%%_dataFinePeriodo_%%/g,
      this.elements.dataFinePeriodo
    );
    completeDoc = completeDoc.replace(
      /%%_dataFinePeriodo_%%/g,
      this.elements.dataFinePeriodo
    );
    completeDoc = completeDoc.replace(
      /%%_cognomeTutore_%%/g,
      this.elements.cognomeTutore
    );
    completeDoc = completeDoc.replace(
      /%%_nomeTutore_%%/g,
      this.elements.nomeTutore
    );
    completeDoc = completeDoc.replace(
      /%%_firmaAllievo_%%/g,
      this.elements.firmaAllievo
    );
    completeDoc = completeDoc.replace(
      /%%_firmaTutore_%%/g,
      this.elements.firmaTutore
    );
    completeDoc = completeDoc.replace(
      /%%_firmaIstituto_%%/g,
      this.elements.firmaIstituto
    );
    return completeDoc;
  }

  close() {
    bus.$emit("closeReview");
  }

  created() {
    data
      .dispatchTemplateDoc(this["$store"], this.docInfo.idTemplate)
      .then(result => {
        this.doc = result;
        // if (this.docInfo.tipoAttivita === "tirocinioReIns") {
        //   this.tipoAttivita = "tirocinio di inserimento/reinserimento";
        // } else if (this.docInfo.tipoAttivita === "tirocinioFormativo") {
        //   this.tipoAttivita = "tirocinio formativo e di orientamento";
        // }
        var userInfo = user.readUserInfo(this["$store"]);
        if (userInfo === null) {
          userInfo = user.readStudentInfo(this["$store"]);
        }
        this.ruoloUtente = userInfo.ruoloUtente;
        this.createDoc();
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });

    // var userInfo = user.readUserInfo(this["$store"]);
    // if (userInfo === null) {
    //   userInfo = user.readStudentInfo(this["$store"]);
    // }
    // this.ruoloUtente = userInfo.ruoloUtente;
    // this.createDoc();
  }
}
